import React from 'react';

import StrokeIcon, { StrokeIconProps } from './StrokeIcon';

export default function TrendingUpIcon(props: StrokeIconProps): JSX.Element {
  return (
    <StrokeIcon {...props}>
      <path d="M16 7h6v6" />
      <path d="m22 7-8.5 8.5-5-5L2 17" />
    </StrokeIcon>
  );
}
